<!--
 * @Description: 须知页
--> 
<template>
  <div class="meter-transfer">
    <van-nav-bar
      left-text="返回"
      :title="$route.meta.title"
      @click-left="$comm.onClickLeft"
      left-arrow
      fixed
      >
      <template #left>
        <span class="iconfont iconshang comm-rotate-270"></span>
        <span class="comm-return">返回</span>
      </template>
    </van-nav-bar>
    <div class="comm-topbar-height" v-show="$comm.titleShow()"></div>
    <div class="main">
      <div class="main-wrapper">
        <div class="main-title">
          阅读业务须知与合同条款
        </div>
        <div v-if="agreeList.length>1" class="main-content">
          <div class="main-item" v-for="(agree, i) in agreeList" :key="i" @click="itemClick(agree)">
            <span class="main-item-txt">{{agree.tit}}</span>
            <span class="iconfont iconshang comm-rotate-90"></span>
          </div>
        </div>
        <div v-if="agreeList.length===1" v-html="agreeList[0].content" class="main-content"></div>
        <van-checkbox
          class="main-agree"
          v-model="checked"
          shape="square"
          checked-color="#1677FF"
          icon-size="16px"
          >
          我已阅读业务须知和合同等条款，并同意。
        </van-checkbox>
        <div class="remark">注：如对业务须知与合同条款等内容有疑义可致客服服热线 85117474。</div>
      </div>
    </div>
    <van-button
      type="info"
      color="#1677FF"
      size="large"
      style="margin-top:23px;height:44px;"
      @click="fillClick()"
      >
      开始填报
    </van-button>
    <van-popup
      v-model="show"
      style="width:85%;height:60%;border-radius:4px;padding:10px 16px;font-size:12px;"
      >
      <div v-html="agreeContent"></div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'MeterTransfer',
  components: {
  },
  data() {
    return {
      checked: false,
      agreeList: [],
      agreeContent: '',
      show: false,
    }
  },
  mounted() {
    this.getAgreeList()
  },
  methods: {
    itemClick (agree) {
      this.agreeContent = agree.content
      this.show = true
    },
    getAgreeList () {
      let typeCode = this.$menuDict[this.$route.meta.title].typeCode
      let params = {
        "typecode": typeCode,
        "pagesize": 99,
        "pageindex": 1
      }
      this.$http.post(this.$api.getArticles, params).then(res => {
        if (res.code==='000') {
          this.agreeList = res.data
        } else {
          this.$toast(res.msg)
        }
      })
    },
    fillClick () {
      if (this.checked) {
        // let path = this.$menuDict[this.$route.meta.next].path
        let path = '/business/yongshuixingzhibiangeng'
        this.$router.push({
          path: path
        })
      } else {
        this.$toast('请先同意合同条款')
      }
    },
  },
}
</script>

<style lang="less" scoped>
.meter-transfer{
  padding: 13px 16px;
  .main{
    background:rgba(255,255,255,1);
    box-shadow:0px 4px 10px 0px rgba(53,126,70,0.08);
    border-radius:4px;
    .main-wrapper{
      padding: 35px 13px;
      .main-title{
        font-size:16px;
        font-family:PingFangSC-Semibold,PingFang SC;
        font-weight:600;
        color:rgba(33,33,33,1);
        text-align: center;
      }
      .main-content{
        margin-top: 73px;
        .main-item{
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-bottom: 1px solid #cccccc;
          height: 44px;
          .main-item-txt{
            font-size:14px;
            font-family:PingFangSC-Regular,PingFang SC;
            font-weight:400;
            color:rgba(33,33,33,1);
          }
          .iconfont{
            color: #999999;
          }
        }
      }
      .main-agree{
        margin-top: 35px;
        font-size:12px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(33,33,33,1);
      }
    }
  }
  .remark{
    font-size:10px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(153,153,153,1);
    text-align: center;
    margin-top: 12px;
  }
}
</style>